import React, { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Form,
  Label,
  Input,
  Button,
  FormFeedback,
} from "reactstrap";
import Breadcrumbs from "components/Common/BreadcrumbTitle";
import {addEvent, getEntity, getMeetingByID, getOneEntity, updateMeeting } from "http/fundLync/entityAndAddress.helper";
import { getDropDownList } from "http/fundLync/dropdown.helper";
import { getUser, getUserByEntityType } from "http/fundLync/user.helper";
import { getEntityWiseDeal } from "http/fundLync/deal.helper";
import ToastDialog from "components/Common/ToastDialog";
import * as Yup from "yup";
import { Formik } from "formik";
import Select from "react-select";
import JoditEditor, { Jodit } from "jodit-react";
import { decryptedValue } from "common/utility";


// Custom styles for react-select
const customStyles = {
  menu: (provided) => ({
    ...provided,
    zIndex: 9999, 
  })
};

const MeetingDetails = () => {
  const { id } = useParams();
  const Id = atob(id);
  const navigate = useNavigate();
  const user = decryptedValue(localStorage.getItem("user"));
  const [toastInfo, setToastInfo] = useState({ showToast: false, message: "", role: "" });
  const currentDate = new Date().toISOString().split("T")[0];
  const [meetingStatus, setMeetingStatus] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [dealList, setDealList] = useState([]);
  const [invitees, setInvitees] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [timezones, setTimezones] = useState([
    { value: "Indian Standard Time (IST)", label: "Indian Standard Time (IST)" }
  ]);
 
  const editor = useRef(null)

  const [initialValues, setInitialValues] = useState({
    id: "",
    entityId: "",
    dealId:"",  
    title: "",
    date: "",
    startTime: "",
    endTime: "",
    invitees: [],
    location: "",
    meetingStatus: "",
    description: "",
  });


  let userDetails = decryptedValue(localStorage.getItem("user"));

  const validationSchema = Yup.object({
    title: Yup.string().required("Meeting Title is required"),
  });


  useEffect(() => {
    getDropDownList({ dropdownName: "Meeting_Status" })
      .then((response) => {
        const dropdownValues =
          response.data?.rows?.find((dv) => dv.dropdownName == "Meeting_Status")
            ?.dropdownValues || [];
        setMeetingStatus(dropdownValues);
      })
      .catch((error) => {
        console.error("Error fetching data", error);
      });

    getMeetingByID({ Id: Id })
      .then((response) => {
        const formattedDate = response.date.split(" ")[0];
         // Format the invitees from the response
        const inviteesArray = response.invitees.split(",").map((invitee) => ({
          value: invitee,
          label: invitee,
        }));

        setInitialValues({ ...response, date: formattedDate, invitees: inviteesArray  });
      })
      .catch((error) => {
        console.error(error);
      });

      let totalValues;
        getEntity()
         .then((response) =>{
          totalValues = response.data.totalItems; 
            getEntity({limit:totalValues})
            .then((response) => {
                setEntityList(response?.data?.data);
            })
            .catch((error) => {
              console.log(error)
            })
         }) 
        .catch((error) => {
          console.log(error)
        })
        
      
  }, [Id]);


  useEffect(() => {
    if (initialValues.entityId) {
       getEntityWiseDeal({ entityId: initialValues.entityId })
        .then((response) => {
          if (response?.data?.rows) {
            setDealList(response.data.rows);
          } else {
            setDealList([]);
          }
        })
        .catch((error) => {
          console.error(error);
          setDealList([]);
        });

        fetchAndSetInvitees(initialValues.entityId);
    }
  }, [initialValues.entityId]);



  const handleEntityChange = (event) => {
    const newEntityId = event.target.value;
    setInitialValues({ ...initialValues, entityId: newEntityId });

    getEntityWiseDeal({ entityId: newEntityId })
      .then((response) => {
        if (response?.data?.rows.length > 0) {
          setDealList(response.data.rows);
        } else {
          setDealList([]);
        }
      })
      .catch((error) => {
        console.error(error);
        setDealList([]);
      });
  };

  const fetchAndSetInvitees = async (id) => {
    
    try {
      // Fetching User Related to Entity
      const userResponse = await getUser({ entityId: id });
      let inviteesList = [];

      if (userResponse.code == 200 && userResponse.status) {
        const formattedUserValues = userResponse?.data?.data.map(item => ({
          value: item.email,
          label: item.firstName
        }));

        // Append the default invitee from userDetails
        const defaultInvitee = {
          value: userDetails.email,
          label: `${userDetails.firstName} ${userDetails.lastName}`
        };
        // inviteesList = [...formattedUserValues];
        inviteesList = [...formattedUserValues, defaultInvitee];
      }

      // Fetch Owner List
      const ownerResponse = await getUserByEntityType();
      const formattedOwnerValues = ownerResponse.map(item => ({
        value: item.email,
        label: `${item.firstName} ${item.lastName}`
      }));

      // Combine the two lists
      const combinedInvitees = [...inviteesList, ...formattedOwnerValues];

      // Set the combined list to invitees
      setInvitees(combinedInvitees);
    } catch (error) {
      console.log(error);
    }
  };

  const handleCreateInvitees = () => {
    const newInvitees = {
      value: inputValue.toLowerCase().replace(/\s+/g, ''),
      label: inputValue,
    };
    setInvitees([...invitees, newInvitees]);
  };
  const handleOptionChange = (value) => {
    setInputValue(value);
  };

  const handleSave = (values) => {
    // Extract text content from HTML string
    const DescriptionText = Jodit.modules.Helpers.stripTags(values.description);
    const inviteesString = values.invitees.map((invitee) => invitee.value).join(',');
      

    const updatedMeeting = {
      id: Id,
      ...values,
      description: DescriptionText,
      invitees: inviteesString,
      
    };


    updateMeeting(updatedMeeting)
      .then((response) => {
        setToastInfo({
          message: "Details Updated Successfully",
          showToast: true,
          role: "success",
        });
        setTimeout(() => {
          navigate(-1)
        }, 2000);
      })
      .catch((error) => {
        console.error(error);
      });

      addEvent(updatedMeeting)
      .then((eventResponse) => {
          console.log("Event created in Microsoft Teams:", eventResponse);
      })
      .catch((error) => {
          console.error("Error creating event in Microsoft Teams:", error);
      });
  };


  const handleCancel = () => {
    navigate(-1);
  };

  const config = {
    removeButtons: ['about'],
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Update Meeting Details" />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSave}
                    enableReinitialize
                  >
                    {({
                      values,
                      errors,
                      touched,
                      handleChange,
                      setFieldValue,
                      handleSubmit,
                    }) => (
                      <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="title">Entity Name</Label>
                            <Input
                              type="select"
                              name="entityId"
                              value={values.entityId}
                              onChange={(e) => {
                                handleChange(e);
                                handleEntityChange(e);
                              }}
                            >
                              {entityList.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.entityName}
                                </option>
                              ))}
                            </Input>
                            
                          </Col>
                          {dealList?.length > 0 && (<Col sm="6">
                            <Label for="title">Deal Name</Label>
                            <Input
                              type="select"
                              name="dealId"
                              value={values.dealId}
                              onChange={handleChange}
                            >
                              {dealList?.length > 0 ?(
                                      <option value="">
                                        Select Deal
                                      </option>
                                    ):(
                                      <option value="">
                                        No Deals Found
                                      </option>
                                    )}
                              {dealList.map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.dealName}
                                </option>
                              ))}
                            </Input>
                          </Col>)}
                        </Row>
                        <Row className="mb-3">
                          <Col sm="6">
                            <Label for="title">Meeting Title</Label>
                            <Input
                              type="text"
                              name="title"
                              value={values.title}
                              onChange={handleChange}
                              invalid={touched.title && !!errors.title}
                            />
                            {touched.title && errors.title && (
                              <FormFeedback>{errors.title}</FormFeedback>
                            )}
                          </Col>

                          <Col sm="6">
                            <Label for="title">Meeting Status</Label>
                            <Input
                              type="select"
                              name="meetingStatus"
                              value={values.meetingStatus}
                              onChange={handleChange}
                            >
                              {meetingStatus.map((item) => (
                                <option key={item.id} value={item.dropdownValue}>
                                  {item.displayName}
                                </option>
                              ))}
                            </Input>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="4">
                            <Label for="date">Meeting Date</Label>
                            <Input
                              type="date"
                              name="date"
                              value={values.date}
                              onChange={handleChange}
                              min={currentDate}
                            />
                          </Col>
                          <Col sm="4">
                            <Label for="date">Start Time</Label>
                            <Input
                              type="time"
                              name="startTime"
                              value={values.startTime}
                              onChange={handleChange}
                            />
                          </Col>
                          <Col sm="4">
                            <Label for="date">End Time</Label>
                            <Input
                              type="time"
                              name="endTime"
                              value={values.endTime}
                              onChange={handleChange}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col sm="4">
                           <Label>Invitees</Label>
                            <Select
                              isMulti
                              name="invitees"
                              options={invitees}
                              onChange={(selectedOption) => setFieldValue("invitees", selectedOption)}
                              onInputChange={handleOptionChange}
                                inputValue={inputValue}
                                isSearchable
                                isClearable
                                noOptionsMessage={() => (
                                  <div>
                                    No options found. 
                                    <a href="#" onClick={(e) => {
                                      e.preventDefault();
                                      handleCreateInvitees();
                                    }}>Add "{inputValue}"</a>
                                  </div>
                                )}
                               value={values.invitees}
                              defaultValue={values.invitees}
                              styles={customStyles}
                              className={touched.invitees && errors.invitees ? 'is-invalid' : ''}
                            />
                          </Col>
                          <Col sm="4">
                           <Label >TimeZone</Label>
                            <Input
                              type="select"
                              name="timezone"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              value={values.timezone}
                            >
                              <option value="" label="Select Relation" disabled />
                              {timezones.map((timezone) => (
                                <option key={timezone.value} value={timezone.value}>
                                  {timezone.label}
                                </option>
                              ))}
                              
                            </Input>
                          </Col>
                          <Col sm="4">
                          <Label >Location</Label>
                            <Input
                              type="text"
                              name="location"
                              onChange={(e) => {
                                handleChange(e);
                              }}
                              value={values.location}
                            >
                            </Input>
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm="12">
                            <Label for="description">Meeting Description</Label>
                            <JoditEditor
                              ref={editor}
                              value={values.description}
                              config={config} 
                              onChange={(newContent) => setFieldValue("description", newContent)}
                            />
                          </Col>
                        </Row>
                        <div className="d-flex justify-content-end">
                           <Button type="submit" style={{ backgroundColor: '#21aa47', borderColor: '#21aa47' }} className="me-2">
                             Update
                          </Button>
                          <Button type="button" 
                            onClick={handleCancel}
                            outline
                            >
                            Cancel
                          </Button>                       
                      </div>
                    </Form>
                   )}
                  </Formik>                
                </CardBody>
              </Card>
            </Col>           
          </Row>
        </Container>
      </div>
      <ToastDialog
        message={toastInfo.message || ""}
        showToast={toastInfo.showToast}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({ showToast: false })}
      ></ToastDialog>
    </React.Fragment>
  );
};

export default MeetingDetails;
